import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, YoutubeIcon } from 'lucide-react';
export function ResourcesSection() {
  return <section id="resurse" className="bg-cream py-20 px-6" data-id="element-260">
      <div className="max-w-4xl mx-auto text-center" data-id="element-261">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-262">
          <div className="text-gold font-label text-xs uppercase tracking-label mb-6" data-id="element-263">
            GHIDURI GRATUITE
          </div>

          <h2 className="text-text-dark font-heading text-4xl md:text-5xl font-bold mb-6" data-id="element-264">
            Claritate înainte de a decide
          </h2>

          <p className="text-text-dark-secondary font-body text-lg leading-relaxed mb-10" data-id="element-265">
            Descarcă ebook-urile gratuite care spulberă miturile despre divorț,
            partaj și moșteniri și îți arată ce zice legea cu adevărat despre
            drepturile tale, înainte de a lua orice decizie.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-266">
            <a href="#" className="inline-flex items-center justify-center gap-2 bg-gold text-navy px-8 py-4 rounded font-label text-sm uppercase tracking-label hover:bg-gold/90 transition-colors" data-id="element-267">
              <BookOpenIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-268" />
              Descarcă Ghidul Gratuit
            </a>
            <a href="https://www.youtube.com/@andreeasaveli" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border-[1.5px] border-gold text-gold px-8 py-4 rounded font-label text-sm uppercase tracking-label hover:bg-gold/10 transition-colors" data-id="element-269">
              <YoutubeIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-270" />
              Urmărește Canalul YouTube
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}